import clsx from 'clsx';
import PropTypes from 'prop-types';

/**
 * Button component for a call to action, with `<a>` linking functionality if specified.
 * If desiring these styles, but not this type of linking, use `<button>` with the
 * `btn` classNames in `buttons.scss`
 */

export function Button({
  ctaText,
  href,
  id,
  rel,
  target,
  variant = 'primary',
  onClick,
}) {
  return (
    <a
      id={id}
      className={clsx(
        'btn',
        {
          primary: null,
          secondary: 'btn--reverse',
          tertiary: 'btn--alt',
          dark: 'btn--dark',
        }[variant],
      )}
      href={href}
      rel={rel}
      target={target}
      onClick={onClick}
      // NOTE: if we do not need `onClick`, with significant refactors to parents,
      // maybe this could be a server component. Not necessarily worth the effort, though
    >
      {ctaText}
    </a>
  );
}

Button.propTypes = {
  classNames: PropTypes.string,
  ctaText: PropTypes.string.isRequired,
  href: PropTypes.string,
  id: PropTypes.string,
  rel: PropTypes.string,
  target: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'dark']),
};
